// --- WeekPicker.js ---
import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import moment from 'moment';
import './WeekPicker.css';

const generateWeekOptions = (year) => {
  const weeks = moment(`${year}-12-31`).isoWeeksInYear();
  return Array.from({ length: weeks }, (_, i) => i + 1);
};

const WeekPicker = ({ onChange }) => {
  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedWeek, setSelectedWeek] = useState(moment().isoWeek());

  useEffect(() => {
    const startDate = moment().year(selectedYear).isoWeek(selectedWeek).startOf('isoWeek').toDate();
    const endDate = moment().year(selectedYear).isoWeek(selectedWeek).endOf('isoWeek').toDate();
    onChange({ week: selectedWeek, startDate, endDate });
  }, [selectedWeek, selectedYear]);

  return (
    <div className="week-picker-wrapper">
      <Row className="align-items-end">
        <Col md={3} sm={6}>
          <Form.Group controlId="yearPicker">
            <Form.Label>Select Year</Form.Label>
            <Form.Control
              as="select"
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
            >
              {Array.from({ length: 5 }, (_, i) => currentYear - 2 + i).map((yr) => (
                <option key={yr} value={yr}>{yr}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={3} sm={6}>
          <Form.Group controlId="weekPicker">
            <Form.Label>Select Week Number</Form.Label>
            <Form.Control
              as="select"
              value={selectedWeek}
              onChange={(e) => setSelectedWeek(parseInt(e.target.value))}
            >
              {generateWeekOptions(selectedYear).map((wk) => (
                <option key={wk} value={wk}>Week {wk}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={6} sm={12} className="week-range-display">
          📅 Week {selectedWeek}: {
            moment().year(selectedYear).isoWeek(selectedWeek).startOf('isoWeek').format('DD MMM')
          } - {
            moment().year(selectedYear).isoWeek(selectedWeek).endOf('isoWeek').format('DD MMM YYYY')
          }
        </Col>
      </Row>
    </div>
  );
};

export default WeekPicker;
